export default __webpack_public_path__ + "static/media/favicon.36b55845.png";